















































































import {Component, Prop} from "vue-property-decorator";
import abpbase from "@/lib/abpbase";
import {EMPTY_ARRAY, EMPTY_OBJECT} from "@/lib/appconst";
import searchInput from "@/components/searchInput.vue";
import basicPage from "@/layouts/basicPage.vue";
import CBreadcrumb from "@/components/cBreadcrumb.vue";

@Component({
    name: 'shortHeaderLayout',
    components: {CBreadcrumb, searchInput}
})
export default class shortHeaderLayout extends abpbase {
    @Prop({type: String, default: ''}) title: string;
    @Prop({type: String, default: ''}) description: string;
    @Prop({type: Array, default: EMPTY_ARRAY}) routes: any;
    @Prop({type: Object, default: EMPTY_OBJECT}) routeTokens: any;
    @Prop({type: Boolean , default: true}) hasHeight: boolean;

    basePath = '';

    defRoutes = [{
        path: 'globalList',
        breadcrumbName: '首页',
    }];

    get rRoutes() {
        return this.defRoutes.concat(this.routes);
    }

    get lastRouteName() {
        let ret = '';
        let lastRoute = this.rRoutes[this.rRoutes.length - 1];
        if (lastRoute) {
            ret = lastRoute.breadcrumbName
        }
        return ret;
    }

    layoutContainerStyle() {
        var ret = '';
        // if (this.hasHeight) {
        //     ret += 'height:calc(100vh - 140px);overflow-y:scroll;';
        // }
        return ret;
    }

    mounted() {
        console.log(this.$store.state.user);
    }

    openUserCenter(){
        if(this.$route.name!=='overview'){
            this.$router.push({
                name:'user'
            })
        }
    }

    logout(e){
        e.stopPropagation();
        this.$store.commit("app/logout");
        location.reload();
    }


}
